import { useEffect, useState } from "react";

/**
 * Returns true if the current page is being rendered inside an iframe
 * (e.g. Emergent preview wrapper). In that environment, browsers block
 * microphone/camera access by default, so recording flows should show
 * a helpful message prompting the user to open the app directly.
 */
export function useIsInIframe() {
  const [isInIframe, setIsInIframe] = useState(false);
  useEffect(() => {
    try {
      setIsInIframe(window.self !== window.top);
    } catch {
      // If accessing window.top throws (cross-origin), we ARE in an iframe.
      setIsInIframe(true);
    }
  }, []);
  return isInIframe;
}

/**
 * Open the current app in the browser's top-level window (escape the iframe).
 * Uses REACT_APP_BACKEND_URL as the canonical preview URL.
 */
export function openInTopWindow() {
  const url = process.env.REACT_APP_BACKEND_URL + window.location.pathname + window.location.search;
  try {
    if (window.top) {
      window.top.location.href = url;
      return;
    }
  } catch {
    // cross-origin — fall through
  }
  window.open(url, "_blank", "noopener,noreferrer");
}
